import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {createGuid} from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';

export const customerTypes = {
  preFullAuthenticated: 'preFullAuthenticated',
  preOtpAuthenticated: 'preOtpAuthenticated',
  preOtpExtendedAuthenticated: 'preOtpExtendedAuthenticated',
  unIdentifiedCustomer: 'unIdentifiedCustomer',
};

export const relevantRolePerCustomerType = {
  preFullAuthenticated: ['NEWCREDENTIALS_ECOMMERCE', 'OTPCUSTOMER_ECOMMERCE', 'OTPSUBSCRIBER_PHONE_NUMBER_ALLOW_ECOMMERCE'],
  preOtpAuthenticated: ['OTPSUBSCRIBER_ECOMMERCE', 'OTPCUSTOMER_ECOMMERCE', 'OTPSUBSCRIBER_PHONE_NUMBER_ALLOW_ECOMMERCE'],
  preOtpExtendedAuthenticated: ['OTPSUBSCRIBER_ECOMMERCE', 'OTPCUSTOMER_ECOMMERCE', 'OTPSUBSCRIBER_PHONE_NUMBER_ALLOW_ECOMMERCE'],
  unIdentifiedCustomer: ['OTPSUBSCRIBER_ECOMMERCE'],
};

export const processPhases = {
  start: 1,
  choseFromSubscriptionList: 2,
  readyToConnect: 3,
  selectOrganization: 4,
};

export const PostEcommerceRegistrationCompletion = createAsyncThunk(
  'ecommerceOtpSlice/PostEcommerceRegistrationCompletion',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('PostEcommerceRegistrationCompletion', [
        data.Scope,
        data.ClientId,
        data.ClientSecret,
        data.LoginType,
        data.Sid,
        data.SubscriberNumber,
        data.Hash,
      ]);
      thunkAPI.dispatch(hideAppLoader());
      return {
        data: result.Body.code.tempToken,
        error: false,
      };
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        data: '',
        error: true,
      };
    }
  },
);

export const GetCustomerSplitSubscriptionNumberList = createAsyncThunk(
  'ecommerceOtpSlice/GetCustomerSplitSubscriptionNumberList',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('GetCustomerSplitSubscriptionNumberList', []);

      thunkAPI.dispatch(hideAppLoader());

      return {
        data: result.Body,
        error: false,
      };
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        data: '',
        error: true,
      };
    }
  },
);
export const GetOrganizationList = createAsyncThunk('ecommerceOtpSlice/GetOrganizationList', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('GetEcommerceOrganizationList', data);

    thunkAPI.dispatch(hideAppLoader());

    return {
      data: result.Body,
      error: false,
    };
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      data: '',
      error: true,
    };
  }
});

export const httpPostRequestPrep = (url, token) => {
  const newWindow = window.open(url + '?tempToken=' + token, '_blank');
  fetch(url, {
    method: 'GET',
    headers: {
      credentials: 'include',
      mode: 'no-cors',
      'temp-token': `${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      newWindow.document.write(JSON.stringify(data));
    })
    .catch((error) => console.error('Error:', error));
  EpiContext.navigateTo();
};

export const createTokenToSessionParamObject = (phoneNumber, loginType) => {
  return {
    Scope: Config.siteScope,
    ClientId: Config.HanutC,
    ClientSecret: Config.Hanut,
    LoginType: loginType,
    Sid: createGuid(),
    SubscriberNumber: phoneNumber,
    Hash: createGuid(),
  };
};

export const connectTokenAndRedirect = createAsyncThunk(
  'ecommerceOtpSlice/connectTokenAndRedirect',
  async ({contactValue, loginType, returnUrl}, thunkAPI) => {
    let ecommRegCompData = createTokenToSessionParamObject(contactValue, loginType);

    thunkAPI.dispatch(PostEcommerceRegistrationCompletion(ecommRegCompData)).then((res) => {
      if (!res?.payload?.error) {
        let redirectToUrl = returnUrl !== '' && returnUrl !== undefined ? returnUrl : Config.ecommerceLink;
        let tempToken = res?.payload?.data;
        window.open(redirectToUrl + '?tempToken=' + tempToken, '_self');
      } else {
        window.open(Config.cellcomShopLink, '_self');
      }
    });
  },
);
export const setCollaborationApproval = createAsyncThunk('ecommerceOtpSlice/setCollaborationApproval', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('ThirdPartyUpdate', [data]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

const initialState = {
  preLoginSplitSubscriptionList: [],
  selectedSubscription: '',
  organizations: [],
};

const ecommerceOtpSlice = createSlice({
  name: 'ecommerceOtp',
  initialState: initialState,
  reducers: {
    setPreLoginSplitSubscriptionList: (state, action) => {
      state.preLoginSplitSubscriptionList = action.payload;
    },
    setSelectedSubscription: (state, action) => {
      state.selectedSubscription = action.payload;
    },
  },
});

export const {setPreLoginSplitSubscriptionList, setSelectedSubscription} = ecommerceOtpSlice.actions;
export default ecommerceOtpSlice.reducer;
